import type { SVGProps } from 'react';

const SvgViewFilled = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 24 24' fill='none' width='1em' height='1em' focusable='false' color='currentColor' {...props}>
    <path
      d='M19 3C19.55 3 20.0204 3.19622 20.4121 3.58789C20.8038 3.97956 21 4.45 21 5V19C21 19.55 20.8038 20.0204 20.4121 20.4121C20.0204 20.8038 19.55 21 19 21H5C4.45 21 3.97956 20.8038 3.58789 20.4121C3.19622 20.0204 3 19.55 3 19V5C3 4.45 3.19622 3.97956 3.58789 3.58789C3.97956 3.19622 4.45 3 5 3H19ZM10.0566 7.62598C9.59014 7.34976 9.00032 7.68551 9 8.22754V15.7012C9 16.2583 9.6195 16.5924 10.085 16.2861L16.0635 12.3525C16.4957 12.0681 16.4804 11.4297 16.0352 11.166L10.0566 7.62598Z'
      fill='currentColor'
    />
  </svg>
);
export default SvgViewFilled;
